import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconModule } from 'src/app/shared/icon/icon.module';

/** Icon per health-check name, so a failing "redis" or "smtp_config" reads at a glance. */
const ICON_BY_CHECK: Record<string, string> = {
  postgres: 'database',
  database: 'database',
  schema: 'code-file',
  mirrors: 'refresh',
  activity: 'clock',
  redis: 'bolt',
  smtp_config: 'mail',
  openai: 'cpu-bolt',
  deepface: 'camera',
  llm_usage_queue: 'inbox',
  probe: 'router',
  ai_service: 'cpu-bolt',
  tenant_gateway: 'globe',
  tenant_admin: 'server',
  super_admin: 'server',
  notification: 'mail',
};

@Component({
  selector: 'app-check-icon',
  standalone: true,
  imports: [CommonModule, IconModule],
  template: `
    <ng-container [ngSwitch]="icon">
      <icon-database *ngSwitchCase="'database'" [class]="class" />
      <icon-code-file *ngSwitchCase="'code-file'" [class]="class" />
      <icon-refresh *ngSwitchCase="'refresh'" [class]="class" />
      <icon-clock *ngSwitchCase="'clock'" [class]="class" />
      <icon-bolt *ngSwitchCase="'bolt'" [class]="class" />
      <icon-mail *ngSwitchCase="'mail'" [class]="class" />
      <icon-cpu-bolt *ngSwitchCase="'cpu-bolt'" [class]="class" />
      <icon-camera *ngSwitchCase="'camera'" [class]="class" />
      <icon-inbox *ngSwitchCase="'inbox'" [class]="class" />
      <icon-router *ngSwitchCase="'router'" [class]="class" />
      <icon-globe *ngSwitchCase="'globe'" [class]="class" />
      <icon-server *ngSwitchCase="'server'" [class]="class" />
      <icon-clipboard-text *ngSwitchDefault [class]="class" />
    </ng-container>
  `,
})
export class CheckIconComponent {
  @Input({ required: true }) name = '';
  @Input() class = 'size-4';

  get icon(): string {
    return ICON_BY_CHECK[this.name] ?? 'default';
  }
}
